import Button from '@material-ui/core/Button/Button';
import { Theme } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../../routes';
import { AppState } from '../../../store';
import { signSetAction } from '../../../store/signup/actions';
import { defaultOrganization } from '../../../store/signup/types';
import { CLICK_ORG_SEARCH_ADD_NEW_BUTTON } from '../../../utils/clevertapEvents';
import { pushEvent } from '../../../utils/clevertapUtils';
import { roundButtonStyles } from './styles';
import icon from '../../../assets/search-icon-big.svg';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        zeroSearchResultStyles: {
            textAlign: 'center',
            '& img': {
                width: 122,
                height: 103,
                marginTop: 43,
                marginBottom: 32,
            },
            '& .text': {
                fontSize: 24,
                fontWeight: 'bold',
            },
            '& .MuiButton-outlinedPrimary': {
                marginTop: theme.spacing(5),
            },
        },
    }),
);

interface ZeroSearchResultsProps {
    term: string;
}

const ZeroSearchResults: React.FC<ZeroSearchResultsProps> = ({ term }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const push = useNavigate();
    const organizationName = useSelector((state: AppState) => ({
        organizationName: state.Signup.organizationName,
    }));
    const { roundButton } = roundButtonStyles();
    const { notFoundText, addNewOrganization } = useMemo(
        () => ({
            notFoundText: t(
                'signup.organizationSearch.zeroSearch.notFoundText',
            ),
            addNewOrganization: t(
                'signup.organizationSearch.zeroSearch.addNewOrganization',
            ),
        }),
        [t],
    );
    const { zeroSearchResultStyles } = useStyles();
    const onClick = () => {
        pushEvent(CLICK_ORG_SEARCH_ADD_NEW_BUTTON, organizationName);
        dispatch(signSetAction(defaultOrganization));
        push(PATH.SIGNUP.STEPS.ADD_ORGANIZATION);
    };
    return (
        <div className={zeroSearchResultStyles}>
            <img src={icon} alt="No Search" title="No Search" />
            <div className="text">
                {notFoundText} "{term}"
            </div>
            <Button
                variant="outlined"
                onClick={onClick}
                className={roundButton}
            >
                {addNewOrganization}
            </Button>
        </div>
    );
};

export default ZeroSearchResults;
